import React from 'react';
import classNames from 'classnames';
import './Avatar.pcss';

type Props = {
  className?: string;
  src?: string;
};

export const Avatar = ({ className, src }: Props) => {
  const styles = src
    ? {
        backgroundImage: `url(${src})`,
      }
    : {
        backgroundColor: '#eee',
      };
  return <div className={classNames(className, 'c-avatar')} style={styles} />;
};
